import React from "react";
import Header from "../../../header/Header";
import NextBtn from "../../../common/NextBtn";
import PrevBtn from "../../../common/PrevBtn";
import Sidebar from "../../../common/Sidebar";
import { useTranslation } from 'react-i18next';

const Chapter04Screen07 = () => {
	const { t, i18n } = useTranslation();
	return (
		<>
			<div className="wrapper bg-bd-2">
				<div
					className="fixed-header"

				>
					<div className="container-fluid cf-set">
						<Header leftChapter="3/4" percentage="75" star="50" />
					</div>
				</div>
				<div className="d-flex">
					<Sidebar />
					<div className="data-adjust">
						<div className="container-fluid cf-set">
							<div className="row align-items-top justify-content-between pt-20 mt-2">
								<div
									className="col-lg-7 wow fadeInDown"
									data-wow-duration="1s"
									data-wow-delay="0.2s"
								>

									<div className="chat-area">
										<div className="left-chat">
											<span>{t('A')}</span>
											<p>{t('M3chapter04Screen07Text1')} </p>
										</div>
										<div className="left-chat right-chat justify-content-end">
											<p>{t('M3chapter04Screen07Text2')}  </p>
											<span>{t('D')}</span>
										</div>

										<div className="left-chat">
											<span>{t('A')}</span>
											<p>{t('M3chapter04Screen07Text3')}  </p>
										</div>
										<div className="left-chat right-chat justify-content-end">
											<p>{t('M3chapter04Screen07Text4')}  </p>
											<span>{t('D')}</span>
										</div>

										<div className="left-chat">
											<span>{t('A')}</span>
											<p>{t('M3chapter04Screen07Text5')}   </p>
										</div>
										<div className="left-chat right-chat justify-content-end">
											<p>{t('M3chapter04Screen07Text6')}  </p>
											<span>{t('D')}</span>
										</div>

										<div className="left-chat">
											<span>{t('A')}</span>
											<p>{t('M3chapter04Screen07Text7')}  </p>
										</div>
										<div className="left-chat right-chat justify-content-end">
											<p>{t('M3chapter04Screen07Text8')}  </p>
											<span>{t('D')}</span>
										</div>

										<div className="left-chat">
											<span>{t('A')}</span>
											<p>{t('M3chapter04Screen07Text9')} </p>
										</div>

										<div className="left-chat right-chat justify-content-end">
											<p>{t('M3chapter04Screen07Text9N')}  </p>
											<span>{t('D')}</span>
										</div>


									</div>


								</div>

								<div
									className="col-lg-5 wow fadeInDown"
									data-wow-duration="1s"
									data-wow-delay="0.2s"
								>
									<center>
										<img
											width="47%"
											draggable="false"
											src="/assets/img/md5/md-5-chap-4-7.png"
											alt=""
										/>
									</center>

									<p className="mb-2 mt-3 text-center">{t('M3chapter04Screen07Text10')}</p>



								</div>



							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="button-fixed wow fadeInDown"
				data-wow-duration="1s"
				data-wow-delay="0.2s"
			>
				<div className="container-fluid cf-set">
					<div className="row">
						<div className="col-lg-12">
							<div className=" d-flex justify-content-end">

								<PrevBtn link="/module-03/chapter-04-screen-06" />
								<NextBtn link="/module-03/chapter-04-screen-08" text={t('CommonBtnGoNext')} />


							</div>
						</div>
					</div>
				</div>
			</div>


		</>
	);
};

export default Chapter04Screen07;
